<template>
    <div class="card card-custom gutter-b">
        <div class="card-header d-flex justify-content-between">
            <div class="card-title">
                <h3 class="card-label">Quản lý công demo</h3>
            </div>
            <div class="card-title">
                <div class="dropdown dropdown-inline">
                    <el-button :loading="loadingExport" @click="exportCongGV"
                               class="btn btn-warning font-weight-bolder">
                        <i class="fa far fa-cloud-download p-0 mr-2"></i> Export Công Giáo viên
                    </el-button>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div class="example mb-10">
                <div class="row">
                    <div class="col-sm-12	col-md-6 col-lg-4	col-xl-2 mt-5">
                        <el-input v-model="query.class_name" clearable placeholder="Tên lớp" class="w-100"></el-input>
                    </div>
                    <div class="col-sm-12	col-md-6	col-lg-4	col-xl-2 mt-5">
                        <el-date-picker
                            value-format="01-MM-yyyy"
                            v-model="query.date" clearable
                            class="w-100" type="month"
                            placeholder="Chọn tháng lớp kết thúc"
                        />
                    </div>
                    <div class="col-sm-12	col-md-6	col-lg-4	col-xl-2 mt-5">
                        <el-select v-model="query.type" clearable placeholder="Loại buổi lớp học" class="w-100">
                            <el-option label="Buổi học chính" value="0"></el-option>
                            <el-option label="Buổi khai giảng" value="1"></el-option>
                            <el-option label="Buổi kết thúc" value="2"></el-option>
                        </el-select>
                    </div>
                    <div class="col-sm-12	col-md-6	col-lg-4	col-xl-2 mt-5">
                        <button class=" btn btn-primary font-weight-bold mr-2"
                                @click="searchData">
                            <i class="fa fa-search"></i> Tìm kiếm
                        </button>
                    </div>
                </div>
                <div class="example-preview table-responsive overflow-auto mt-3">
                    <table class="table table-hover table-bordered table-vertical-center b-table"
                           style="text-align: center">
                        <thead>
                        <tr>
                            <th scope="col" class="min-w-100px">STT</th>
                            <th scope="col" class="min-w-100px">Lớp</th>
                            <th scope="col" class="min-w-100px">Tên GV - Mã GV</th>
                            <th scope="col" class="min-w-100px">Ngày KG</th>
                            <th scope="col" class="min-w-100px">Ngày KT</th>
                            <th scope="col" class="min-w-100px">Số buổi học chính</th>
                            <th scope="col" class="min-w-100px">Số buổi KG/TK</th>
                            <th scope="col" class="min-w-100px">Số buổi kiểm tra</th>
                            <th scope="col" class="min-w-100px">Số công trừ</th>
                        </tr>
                        </thead>
                        <tbody>
                        <template v-for="(item, index) in exportList">
                            <tr>
                                <td>{{ getIndexPaginate(pagination.current_page, index, 18) }}</td>
                                <td>{{ item.classroom_name }}</td>
                                <td>{{ item.teacher_name }} - {{ item.teacher_id }}</td>
                                <td>{{ item.start_date | formatDate }}</td>
                                <td>{{ item.end_date | formatDate }}</td>
                                <td>{{ item.so_buoi_hoc_chinh }}</td>
                                <td>{{ item.so_buoi_khai_giang_tong_ket }}</td>
                                <td>{{ item.so_buoi_kiem_tra }}</td>
                                <td class="deduction-action" @click="getDeductionClassroom(item)">
                                    <span>{{ item.number_deduction ?? 0 }}  công</span>
                                </td>
                            </tr>
                        </template>
                        <tr v-if="exportList.length === 0 && !loading">
                            <td colspan="9" class="event-title no-data">Chưa có dữ liệu</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="position-absolute" style="right:40px">
                    Tổng số bản ghi: <b style="color:#3699FF">{{ total }}</b>
                </div>
            </div>
        </div>
        <div class="edu-paginate mx-auto text-center">
            <paginate v-model="page" :page-count="last_page" :page-range="3" :margin-pages="1"
                      :click-handler="clickCallback"
                      :prev-text="'Trước'" :next-text="'Sau'" :container-class="'pagination b-pagination'"
                      :pageLinkClass="'page-link'" :next-link-class="'next-link-item'"
                      :prev-link-class="'prev-link-item'"
                      :prev-class="'page-link'" :next-class="'page-link'" :page-class="'page-item'">
            </paginate>
        </div>
        <el-dialog
            class="responsive" v-if="isShowDeduction"
            :visible.sync="isShowDeduction" :show-close="false"
        >
            <template #title>
        <span style="width: 100%; text-align: start; display: block; font-size: 20px; font-weight: 700">{{
                `Công trừ lớp ${classroomSelected.classroom_name}`
            }}</span>
            </template>
            <hr style="margin-top: -25px; margin-bottom: 25px;"/>
            <TableDeduction
                v-loading="isBusy"
                :deduction-list="deductionList"
                :classroom="classroomSelected"
                @get-list-deduction="getDeductionClassroom"
            />
            <div style="display: flex; justify-content: end">
                <el-button @click="isShowDeduction = false" type="info">Đóng</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>

import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import ClassTimesheetItem from "./components/ClassTimesheetItem.vue";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import DialogConfirmExportCertificate from "./components/DialogConfirmExportCertificate.vue";
import TableImportError from "../tax-invoice/components/TableImportError.vue";
import TableImportErrorGlobal from "./TableImportErrorGlobal.vue";
import {EXPORT_CLASS_ATTENDANCE} from "@/core/services/store/export/export.module";
import {GET_TEACHER_GROUPS} from "@/core/services/store/teacher/teacher.module";
import {CLASS_EXPORT_ATTENDANCE_LIST, GET_DEDUCTION_BY_CLASSROOM} from "@/core/services/store/course/classes.module";
import TableDeduction from "@/view/pages/classes/components/TableDeduction.vue";

export default {
    components: {
        TableDeduction,
        TableImportErrorGlobal,
        TableImportError,
        DialogConfirmExportCertificate,
        ClassTimesheetItem,
        DatePicker
    },
    name: "ExportTeacherAttendance",
    data() {
        return {
            query: {
                class_name: '',
                date: '',
                type: '',
            },
            uploading: false,
            listCertificate: [],
            exportList: [],
            pagination: [],
            is_disable_search: false,
            last_page: 1,
            page: 1, total: 0,
            loading: true,
            loadingExport: false,
            listTeacherGroup: [],
            deductionList: [],
            isBusy: false,
            isShowDeduction: false,
            classroomSelected: null
        };
    },

    async mounted() {
        await this.$store.dispatch(SET_BREADCRUMB, [
            {title: "Quản lý công demo"},
            {title: "Quản lý dạy học"},
        ]);
        this.query = this.$router.currentRoute.query;
        this.callApiGetList();
        this.getTeacherGroups();
    },
    methods: {
        closeDialog() {
            this.is_dialog_option = false
            this.is_dialog_attendance = false
            this.isCertificate = false
            this.is_disable_export = false
            this.type_export = 1
        },
        pushParamsUrl() {
            this.$router.push({
                name: 'export-teacher-timesheets',
                query: {
                    page: this.page,
                    ...this.query
                }
            })
        },
        searchData() {
            this.page = 1
            this.is_disable_search = true
            this.pushParamsUrl()
            this.callApiGetList()
        },
        callApiGetList() {
            let payload = {};
            payload = {...this.query, page: this.page}
            this.$store.dispatch(CLASS_EXPORT_ATTENDANCE_LIST, payload)
                .then((res) => {
                    if (!res.error) {
                        this.loading = false
                        this.exportList = res.data?.data ?? res.data;
                        this.pagination = res.pagination ?? {};
                        this.last_page = res.last_page ?? res.pagination.last_page;
                        this.total = res.total ?? res.pagination.total;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getTeacherGroups() {
            this.$store.dispatch(GET_TEACHER_GROUPS).then((data) => {
                this.listTeacherGroup = data.data
                this.listTeacherGroup.splice(0, 0, {id: 0, name: '(Không có nhóm)'})
            })
        },
        handleChange(file, fileList) {
            this.fileList = fileList
            this.fileImport = file.raw;
            this.disableImport = false;
            this.parseExcel(this.fileImport);
        },
        handleRemove() {
            this.fileList = []
            this.listErrors = [];
            this.checkImport = false;
            this.disableImport = true;
            this.startImport = true;
        },
        clickCallback(obj) {
            this.page = obj
            this.$router.push({
                name: 'export-teacher-timesheets',
                query: {
                    page: this.page,
                    ...this.query
                }
            })
            this.callApiGetList()
        },
        exportCongGV() {
            this.loadingExport = true;
            this.$store.dispatch(EXPORT_CLASS_ATTENDANCE, {export: 1})
                .then((res) => {
                    this.loadingExport = false;
                    this.download_default = false
                    this.$notify({
                        title: 'Thành công',
                        message: res.message,
                        type: 'success'
                    })
                }).catch((error) => {
                this.loadingExport = false;
                this.$notify({
                    title: 'Thất bại',
                    message: error.message,
                    type: 'error'
                })
            })
        },
        getDeductionClassroom(classroom) {
            this.isBusy = true
            this.isShowDeduction = true
            this.classroomSelected = classroom
            const payload = {
                classroom_id: classroom.classroom_id
            }
            this.$store.dispatch(GET_DEDUCTION_BY_CLASSROOM, payload).then(res => {
                if (!res.error) {
                    this.deductionList = res.data
                }
            }).catch(e => {
                console.log(e)
            }).finally(() => this.isBusy = false)
        }
    },
};
</script>
<style lang="scss" scoped>
.deduction-action {
    cursor: pointer;
}

.deduction-action:hover {
    text-decoration: underline;
    color: #1da1f2
}
</style>
